module.exports = __webpack_public_path__ + "img/show_cn_text_4.afe6cbe5.png";